export const UPLOAD_FILE_TIMEOUT = 120000;
